import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from '@angular/common';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SubscriptionLike, combineLatest, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  ShareReportModalComponent
} from "../../components/reference-report-content/components/share-report-modal/share-report-modal.component";
import {
  ReplaceReferenceModalComponent
} from "../../components/reference-report-content/components/replace-reference-modal/replace-reference-modal.component";
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { SurveyService } from 'src/app/services/survey/survey.service';
import {
  ExportSettingsModalComponent
} from 'src/app/components/reference-report-content/components/export-settings-modal/export-settings-modal.component';
import {
  ReferencesReportHelpModalComponent
} from "../../components/references-report-help-modal/references-report-help-modal.component";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { ConstantsService } from "../../services/constants/constants.service";
import { ReferencesService } from 'src/app/services/references/references.service';
import { QuestionnaireService } from "../../services/questionnaire/questionnaire.service";

@Component({
  selector: 'app-reference-report',
  templateUrl: './reference-report.component.pug',
  styleUrls: ['./reference-report.component.scss'],
  standalone: false
})
export class ReferenceReportComponent implements OnInit, OnDestroy {
  private bsModalRef: any;
  checkId: any;
  private refereeId: any;
  replaceButtonStatus = false;
  data: any;
  headingsData: any;
  loaded = false;
  referenceReportHelpModal: BsModalRef;
  managePermissions = {}
  hasSharePermission = false;
  sharePermissionTooltipText = '';
  contactLink = ConstantsService.CONTACT_US;
  email: any;
  hideReplaceButton = false;
  recCheck = false;
  requestRolePermissionShare = false;
  canManageReferenceRequest = false;
  canManageReferenceRequestWithSurveyPerm = false;
  canManageOwnReferenceRequest = false;
  canManageIntegrationUserRequest = false;
  memberContributorPermission = false;
  IntegrationUserPermission = false;
  backButtonFF = false;
  private locationSubscription: SubscriptionLike | null = null;
  private exportModalSubscription: SubscriptionLike | null = null;
  securityLogUserMistmatchesFF = false;

  get originPage() {
    return $localize`Requests`
  };
  constructor(
      private route: ActivatedRoute,
      public router: Router,
      public modalService: BsModalService,
      private alertList: AlertBannerService,
      private surveyService: SurveyService,
      private permissionsService: PermissionsService,
      public organisationService: OrganisationService,
      private reference: ReferencesService,
      private questionnaireService: QuestionnaireService,
      private location: Location,
  ) {
    this.referenceReportHelpModal = new BsModalRef();
  }

  ngOnInit(): void {
    this.backButtonFF = this.permissionsService.isFeatureActivated('ent-9960-back-button');
    this.hasSharePermission = this.permissionsService.isOrgFeatureEnabled('share_track');
    this.securityLogUserMistmatchesFF = this.permissionsService.isFeatureActivated('ent-10293-adjust-consistency-of-security-logs-user-mismatches');
    this.sharePermissionTooltipText = !this.hasSharePermission ? $localize`Upgrade to enable this feature. Click to request access.` : '';
    if (this.permissionsService.hasPermission('share_and_track_own_report')) {
      this.managePermissions['share_and_track_own_report'] = true;
    }
    if (this.permissionsService.hasPermission('share_and_track_any_report')) {
      this.managePermissions['share_and_track_any_report'] = true;
    }
    if (this.permissionsService.hasPermission('share_rec_request_report')) {
      this.managePermissions['share_rec_request_report'] = true;
    }

    this.canManageReferenceRequest = this.permissionsService.hasPermission('can_manage_reference_requests')
    this.canManageReferenceRequestWithSurveyPerm = this.permissionsService.hasPermission('can_manage_reference_requests_with_survey_perms')
    this.canManageOwnReferenceRequest = this.permissionsService.hasPermission('can_manage_own_reference_requests')
    this.canManageIntegrationUserRequest = this.permissionsService.hasPermission('can_manage_integrationuser_requests_restricted')
    if (this.backButtonFF) {
      this.browserBackButtonClickEvent();
    }
    this.route.params.subscribe((params: any) => {
      this.checkId = params.checkId;
      this.refereeId = params.refereeId;
      this.getReport();
      this.getReplaceRefereeStatus();
      this.getQuestionnairePermissions();
      this.getReferenceRequest();
    });

  }

  browserBackButtonClickEvent() {
    this.locationSubscription = this.location.subscribe((event) => {
      if (event.type === 'popstate') {
        this.navigateBack();
      }
    });
  }

  navigateBack() {
    const previousUrl = localStorage.getItem('previousUrl');
    this.router.navigate([previousUrl], {state: {'from': 'referenceReportPage', 'checkId': this.checkId}});
  }

  elementID(id: string): void {
    let element: HTMLElement | null = document.getElementById(id)
    if (element) {
      const header: HTMLElement | null = document.getElementById("reference-header");
      const headerHeight: number = header ? header.offsetHeight : 0;

      const elementPosition: number = element.getBoundingClientRect().top;
      const offsetPosition: number = elementPosition - headerHeight;


      window.scrollBy({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  showShareReportModal() {
    const hasQuestionnairePermission = this.managePermissions['user_questionnaire_permission'];
    const canManage = this.canManageReferenceRequestWithSurveyPerm || this.memberContributorPermission;

    if (!hasQuestionnairePermission && canManage) {
      return;
    }

    let initialState = {
      "checkId": this.checkId,
      "refereeId": this.refereeId
    }

    if (!this.hasSharePermission) {
      window.open(this.contactLink, "_blank");
      return;
    } else {
    this.bsModalRef = this.modalService.show(ShareReportModalComponent,  Object.assign({}, { class: 'modal-dialog-centered share-track-modal', initialState }));
    }
  }



  showReplaceReferenceModal() {
    let initialState = {"refereeId": this.refereeId, "checkId": this.checkId};
        this.bsModalRef = this.modalService.show(ReplaceReferenceModalComponent, {
        class: 'modal-dialog-centered', initialState
      });

   this.bsModalRef.content.referenceReplaceStatus.subscribe(res => {
     if (res === 'Success') {
       this.hideReplaceButton = true;
     }
    })
  }

  showExportSettingsModal() {
    // Unsubscribe from any existing subscription to prevent memory leaks
    if (this.exportModalSubscription) {
      this.exportModalSubscription.unsubscribe();
    }

    if (this.securityLogUserMistmatchesFF) {
      // Use combineLatest to make parallel API calls with individual error handling
      this.exportModalSubscription = combineLatest({
        permissions: this.permissionsService.getPermissions().pipe(
          catchError(() => of(null))
        ),
        organisation: this.organisationService.getOrganisation().pipe(
          catchError(() => of(null))
        )
      }).subscribe(({ permissions, organisation }) => {
        const userUId = permissions?.user?.uid || null;
        const orgUId = organisation?.uid || null;
        
        const initialState: any = {
          "refereeId": this.refereeId,
          'checkId': this.checkId,
          'competencies': this.data?.['competencies'],
          'modifications': this.data?.['referee']?.['modifications'],
          'user_uid': userUId, //optional
          'org_uid': orgUId //optional
        };
        
        this.bsModalRef = this.modalService.show(ExportSettingsModalComponent, {
          class: 'modal-dialog-centered max-width-349', initialState
        });
      });
    } else {
      // Show modal immediately if feature flag is not enabled
      const initialState = {
        "refereeId": this.refereeId,
        'checkId': this.checkId,
        'competencies': this.data?.['competencies'],
        'modifications': this.data?.['referee']?.['modifications']
      };
      
      this.bsModalRef = this.modalService.show(ExportSettingsModalComponent, {
        class: 'modal-dialog-centered max-width-349', initialState
      });
    }
  }

  getQuestionnairePermissions() {
    this.questionnaireService.getUserQuestionnairePermissions(this.checkId).subscribe(
      response => {
        this.managePermissions['access_questionnaire_permissions'] = response.data['questionnaire_permission']
      },
      error => {
        this.alertList.append([{
          active: true,
          type: AlertType.DANGER,
          message: 'Oops! Something went wrong. Our developers have been notified. Feel free to try again.',
        }]);
      }
    )
  }

  getReferenceRequest() {
    this.reference.getCheck(this.checkId).subscribe({
      next: response => {
        this.managePermissions['user_questionnaire_permission'] = response['user_questionnaire_permission']
        this.memberContributorPermission = response['user_own_request'] && this.canManageOwnReferenceRequest
        this.IntegrationUserPermission = response['is_integration_request'] && this.canManageIntegrationUserRequest

        if (response['integration_sub'] != ConstantsService.ENTERPRISE_PLATFORM_NAME) {
          this.recCheck = true;
        }
        if (this.recCheck && this.managePermissions['share_rec_request_report']) {
            this.requestRolePermissionShare = true;
          }
          else if (!this.recCheck && (
            this.managePermissions['share_and_track_any_report'] || this.managePermissions['share_and_track_own_report'])) {
            this.requestRolePermissionShare = true;
          }
      },
      error: error => {
        if (error.status === 403) {
          this.router.navigate(['/no-access']);
        }
        this.alertList.append([{
          active: true,
          type: AlertType.DANGER,
          message: 'Oops! Something went wrong. Our developers have been notified. Feel free to try again.',
        }]);
      }
    });
  }

  /**
   * Get Xref report data.
   *
   * Success - Check if loaded
   * Error - Display alert
   */
  private getReport() {
    const getReportSuccess = (resp) => {
      this.isLoaded();
      this.data = resp;
    };

    const getReportError = () => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    };

    this.surveyService
      .getReport(this.checkId, this.refereeId, getReportSuccess, getReportError);
  }

  private getReplaceRefereeStatus() {
    const getReplaceRefereeStatusSuccess = (resp) => {
      this.replaceButtonStatus = resp['data']['replace_button'];
    };

    const getReplaceRefereeStatusError = () => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    };
      this.surveyService
        .getReplaceRefereeStatus(this.checkId, this.refereeId).subscribe(getReplaceRefereeStatusSuccess, getReplaceRefereeStatusError);
    }


  userAvatar() {
    if (this.loaded) {
      let name = this.data['candidate']['name'];
      return name.split(' ')[0].toUpperCase()[0] + name.split(' ')[1].toUpperCase()[0];
    }
    return ''
  }

  headersData() {
    if (this.loaded) {
      return this.headingsData = {
        "heading_section_1": $localize`General`,
        "section_1_subheading_1": $localize`Unusual activity`,
        "section_1_subheading_2": $localize`Summary`,
        "heading_section_2": $localize`Candidate`,
        "section_2_subheading_1": $localize`Candidate details`,
        "section_2_subheading_2": $localize`Candidate responses`,
        "heading_section_3": $localize`Referee`,
        "section_3_subheading_1": $localize`Referee details`,
        "section_3_subheading_2": $localize`Referee modifications`,
        "section_3_subheading_3": $localize`Referee feedback`,
        "section_3_subheading_4": $localize`Referee feedback`,
        "section_3_subheading_5": $localize`Referee opt-in/out`,
        "section_3_subheading_6": $localize`Attachments`
      }


    } else {
      return {};
    }
  }

  /**
   * Check if all data has been loaded before setting loaded to true and create
   * any moments needed for the page.
   */
  private isLoaded() {
    if (this.surveyService.hasData()) {
      this.loaded = true;
    }
  }


  showHelp() {
    this.referenceReportHelpModal = this.modalService.show(ReferencesReportHelpModalComponent, {
      class: 'modal-dialog-centered modal-lg'
    });
  }

  ngOnDestroy(): void {
    if (this.locationSubscription) {
      this.locationSubscription.unsubscribe();
    }
    if (this.exportModalSubscription) {
      this.exportModalSubscription.unsubscribe();
    }
  }
}
